module.exports = __webpack_public_path__ + "img/linkedin.a7f30fc5.png";